module.exports = {"140882001":"城区街道","140882002":"清涧街道","140882100":"樊村镇","140882101":"僧楼镇","140882200":"小梁乡","140882201":"柴家乡","140882202":"赵家庄乡","140882203":"下化乡","140882204":"阳村乡","140882450":"山西铝厂"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140882.json
// module id = 345
// module chunks = 0